import EventTypes from "@wesstron/utils/Api/constants/eventTypes";
import {groupBy, uniq, uniqBy} from "lodash";
import {AnimalTypes} from "../constans/animalTypes";
import animalsDB from "../database/animalsDB";
import eventsDB from "../database/eventsDB";
import groupsDB from "../database/groupsDB";
import {preEvents} from "./AnimalDocumentsUtils";
import {calculateAnimalParameters} from "./AnimalParamUtils";
import {calculateGroupParameters} from "./GroupParamUtils";
import {getAnimalTimespanInGroupByAllEvents} from "./GroupUtils";
import {isBetween} from "./MathUtils";

export const eventHierarchy = {
    [EventTypes.PIGLET_RECLASSIFY]: 0,
    [EventTypes.TRANSFER]: 1,
    Other: 2,
};

/**
 * Funkcja sprawdzająca, które rzeczy ma obliczyć
 * @param {*} farm
 * @param {*} animalChanges
 * @param {*} fullCalc
 * @returns
 */
function getAnimalsToCalc(farm, animalChanges, fullCalc) {
    if (fullCalc) {
        return {
            animals: [
                ...animalsDB.getAllAnimals(
                    farm,
                    AnimalTypes.SOW,
                    true,
                    false,
                    false
                ),
                ...animalsDB.getAllAnimals(
                    farm,
                    AnimalTypes.RENOVATION_SOW,
                    true,
                    false,
                    false
                ),
            ],
            groups: groupsDB.getAllGroups(farm, {showDeleted: true}),
        };
    }
    const animals = [];
    const groups = [];
    let uniqChanges = uniq(animalChanges);
    for (let AnmID of uniqChanges) {
        const animal = animalsDB.getAnimalById(AnmID, {
            joinEvents: false,
            findDeleted: true,
        });
        if (animal.AnimalKind === AnimalTypes.SOW) {
            animals.push(animal);
        } else {
            const group = groupsDB.getGroupWithAnimal(animal.AnmID, farm);
            groups.push(...group);
        }
    }
    return {animals, groups: uniqBy(groups, "AnmGrp")};
}

export function calculateAnimalParametersForAllAnimals(
    farm,
    utilResults,
    buildingsMap,
    animalChanges,
    fullCalc
) {
    console.log(utilResults);
    const {animals, groups} = getAnimalsToCalc(farm, animalChanges, fullCalc);
    console.log(
        "[calculateAnimalParametersForAllAnimals] Calculating for",
        animals.length,
        groups.length
    );
    console.log(animals);

    const events = eventsDB
        .getAllEventsForFarm(farm)
        .sort((a, b) => a.EvTime - b.EvTime);
    console.log(animals.length, groups.length, events.length);
    const groupedEvents = groupBy(events, "AnmID");
    console.log(groupedEvents);
    console.time("calculateAnimalParametersForAllAnimals");
    const res = [];
    for (let animal of animals) {
        const animalEvents = groupedEvents[animal.AnmID];
        const cycles = preEvents(animalEvents, animal, false, utilResults);
        const result = calculateAnimalParameters(
            animal,
            animalEvents,
            cycles.cycleTable,
            utilResults,
            buildingsMap,
            groups
        );
        res.push(...result);
    }
    for (let group of groups) {
        let groupEvents = [];
        let groupAnimals = [];
        for (let AnmID of uniq([...group.AnmIDs, ...group.Rmvd])) {
            groupAnimals.push(
                animalsDB.getAnimalById(AnmID, {
                    joinEvents: false,
                    findDeleted: true,
                })
            );
            groupEvents.push(...(groupedEvents[AnmID] || []));
        }
        groupEvents.sort((a, b) => {
            const diff = a.EvTime - b.EvTime;
            if (diff !== 0) return diff;
            return (
                (eventHierarchy[a.EvCode] || eventHierarchy.Other) -
                (eventHierarchy[b.EvCode] || eventHierarchy.Other)
            );
        });
        const animalTimespan = getAnimalTimespanInGroupByAllEvents(
            groupEvents,
            group.AnmGrp
        );
        groupEvents = groupEvents.filter((ev) => {
            if (!animalTimespan[ev.AnmID]) return true;
            return animalTimespan[ev.AnmID].some((range) =>
                isBetween(ev.EvTime, range[0], range[1])
            );
        });
        const result = calculateGroupParameters(
            group,
            groupAnimals,
            groupEvents,
            buildingsMap,
            utilResults
        );
        // console.log(result);
        res.push(...result);
    }
    console.log(res);
    console.timeEnd("calculateAnimalParametersForAllAnimals");
    return {
        parameters: res,
        animals: fullCalc ? undefined : animals.map((a) => a.AnmID), // oszczedzanie czasu, gdy liczone jest wszystko
        groups: fullCalc ? undefined : groups.map((g) => g.AnmGrp),
    };
}

// export async function calculateAnimalParametersForAllAnimals2(
//     farm,
//     utilResults,
//     buildingsMap,
//     {fullCalc, animalChanges}
// ) {
//     if (!fullCalc) {
//         return [];
//     }
//     const span = BugsnagPerformance.startSpan("Animal parameters");
//     const helper = new ControlList({FarmID: farm});
//     helper.TryMakeUiResponsive.Init();
//     const animals = animalsDB.getAllAnimals(
//         farm,
//         AnimalTypes.SOW,
//         true,
//         false,
//         false
//     );
//     const groups = groupsDB.getAllGroups(farm, {showDeleted: true});
//     const events = eventsDB
//         .getAllEventsForFarm(farm)
//         .sort((a, b) => a.EvTime - b.EvTime);
//     const animalDict = createKeyToValueDictionary(animals, "AnmID");
//     const isAnimalEligibleForTimespan = memoize((AnmID) => {
//         const animal = animalDict[AnmID];
//         if (!animal) return false;
//         return !isSubgroup(animal);
//     });
//     const groupedEvents = groupBy(events, "AnmID");
//     const res = [];
//     for (let animal of animals) {
//         const animalEvents = groupedEvents[animal.AnmID];
//         const cycles = preEvents(animalEvents, animal, false, utilResults);
//         const result = calculateAnimalParameters(
//             animal,
//             animalEvents,
//             cycles.cycleTable,
//             utilResults,
//             buildingsMap
//         );
//         res.push(...result);
//         await helper.TryMakeUiResponsive();
//     }
//     for (let group of groups) {
//         let groupEvents = [];
//         for (let AnmID of uniq([...group.AnmIDs, ...group.Rmvd])) {
//             groupEvents.push(...(groupedEvents[AnmID] || []));
//         }
//         groupEvents.sort((a, b) => {
//             const diff = a.EvTime - b.EvTime;
//             if (diff !== 0) return diff;
//             return (
//                 (eventHierarchy[a.EvCode] || eventHierarchy.Other) -
//                 (eventHierarchy[b.EvCode] || eventHierarchy.Other)
//             );
//         });
//         const animalTimespan = getAnimalTimespanInGroupByAllEvents(
//             groupEvents,
//             group.AnmGrp,
//             {
//                 isAnimalSupported: isAnimalEligibleForTimespan,
//             }
//         );
//         groupEvents = groupEvents.filter((ev) => {
//             if (!animalTimespan[ev.AnmID]) return true;
//             return animalTimespan[ev.AnmID].some((range) =>
//                 isBetween(ev.EvTime, range[0], range[1])
//             );
//         });
//         const result = calculateGroupParameters(
//             group,
//             groupEvents,
//             buildingsMap,
//             utilResults
//         );
//         res.push(...result);
//         await helper.TryMakeUiResponsive();
//     }
//     span.end();
//     return res;
// }
